import React, { useEffect, useState } from 'react'
import { useGetYarnMasterQuery } from "../../../redux/ErpServices/YarnMasterServices";
import { useGetUnitOfMeasurementMasterQuery } from "../../../redux/ErpServices/UnitOfMeasurementServices";
import secureLocalStorage from 'react-secure-storage';
import { Loader } from '../../../Basic/components';
import { useGetColorMasterQuery } from '../../../redux/ErpServices/ColorMasterServices';
import { findFromList, getDateFromDateTime, getAllowableReturnQty, substract } from '../../../Utils/helper';

const YarnPoItemSelection = ({ poItems, addItem, removeItem, isItemInPoAdded, storeId, inwardOrReturn }) => {
    const [localItems, setLocalItems] = useState([]);

    const [searchFilter, setSearchFilter] = useState([]);

    useEffect(() => {
        let fullList = []
        poItems.forEach((poItem) => {
            poItem.poItems.forEach((item) => {
                if (inwardOrReturn === "PurchaseInward" || inwardOrReturn === "PurchaseCancel") {
                    if ((item.alreadyInwardedQty + item.alreadyReturnedQty) !== substract(item.qty, item.alreadyCancelQty)) {
                        fullList.push({ ...item, poDocId: poItem.docId, poNo: poItem.id, poDate: poItem.createdAt, dueDate: poItem.dueDate, poItemId: item.poItemId })
                    }
                } else {
                    if (getAllowableReturnQty(item.alreadyInwardedQty, item.alreadyReturnedQty, item.stockQty) !== 0) {
                        fullList.push({ ...item, poDocId: poItem.docId, poNo: poItem.id, poDate: poItem.createdAt, dueDate: poItem.dueDate, poItemId: item.poItemId })
                    }
                }
            })
        })
        setLocalItems(fullList);
    }, [poItems, setLocalItems, searchFilter])

    function filterRecords(localItems) {
        let newLocalItems = [...localItems]
        newLocalItems = newLocalItems.filter(item => {
            for (let filter of searchFilter) {
                let fieldName = filter.fieldName
                let searchValue = filter.searchValue
                let objTransformFunc = filter.objTransformFunc
                let itemObj = objTransformFunc(item[fieldName])
                if (!(`${itemObj}`.toLowerCase().includes(searchValue.toLowerCase()))) return false
            }
            return true
        })
        return newLocalItems
    }

    useEffect(() => {
        setLocalItems(prev => filterRecords(prev))
    }, [setLocalItems, searchFilter, poItems])


    const companyId = secureLocalStorage.getItem(
        sessionStorage.getItem("sessionId") + "userCompanyId"
    )
    const { data: yarnList, isLoading: yarnListLoading, isFetching: yarnListFetching } = useGetYarnMasterQuery({ companyId })
    const { data: uomList, isLoading: uomLoading, isFetching: uomFetching } = useGetUnitOfMeasurementMasterQuery({ companyId })
    const { data: colorList, isLoading: colorLoading, isFetching: colorFetching } = useGetColorMasterQuery({ companyId })

    if (yarnListLoading || yarnListFetching || uomFetching || uomLoading || colorFetching || colorLoading) {
        return <tr>
            <td>
                <Loader />
            </td>
        </tr>
    }

    function handleCheckBoxChange(poNo, value, poItemId) {
        if (value) {
            addItem(poNo, poItemId)
        } else {
            removeItem(poNo, poItemId)
        }
    }

    function handleSelectAllChange(value) {
        if (value) {
            localItems.forEach(item => addItem(item.poNo, item.poItemId))
        } else {
            localItems.forEach(item => removeItem(item.poNo, item.poItemId))
        }
    }

    function getSelectAll() {
        return localItems.every(item => isItemInPoAdded(item.poNo, item.poItemId))
    }


    function changeSearchFilter(field, value, objTransformFunc) {
        setSearchFilter(prev => {
            if (!value) {
                return prev.filter(item => item.fieldName !== field)
            }
            let newSearchFilter = [...prev]
            let index = newSearchFilter.findIndex(item => item.fieldName === field)
            if (index !== -1) {
                newSearchFilter[index]["searchValue"] = value
            } else {
                newSearchFilter.push({ fieldName: field, searchValue: value, objTransformFunc });
            }
            return newSearchFilter
        })
    }

    let count = 1;
    return (
        <div className='border  bg-gray-200'>
            <table className='table-fixed w-full text-xs border border-gray-500'>
                <thead className='border border-gray-500'>
                    <tr className='bg-blue-200  sticky top-10 '>
                        <th className=''>
                        </th>
                        <th className='text-center table-data'>
                            S.no
                        </th>
                        <th className='text-center table-data w-32'>
                            Po.no
                        </th>
                        <th className='text-center table-data'>
                            Po.Date
                        </th>
                        <th className='text-center table-data'>
                            Due Date
                        </th>
                        <th className='table-data'>
                            Yarn Name
                        </th>
                        <th className='table-data'>
                            Color
                        </th>
                        <th className='table-data'>
                            Uom
                        </th>
                        <th className='table-data'>
                            Po qty
                        </th>
                        <th className='table-data'>
                            Already Inwarded qty
                        </th>
                        <th className='table-data'>
                            Balance qty
                        </th>
                        <th className='table-data'>
                            Stock qty
                        </th>
                        <th className='table-data'>
                            Price
                        </th>
                        <th className='table-data'>
                            Gross
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='sticky top-20 bg-blue-200'>
                        <td className='text-center table-data '>
                            <input type="checkbox" onChange={(e) => handleSelectAllChange(e.target.checked)}
                                checked={getSelectAll()}
                            />
                        </td>
                        <td className='text-center table-data'>
                        </td>
                        <td className='text-center table-data'>
                            <input className='w-full p-2' type="text" placeholder='Search'
                                onChange={(e) => {
                                    changeSearchFilter("poNo", e.target.value, (item) => item)
                                }} />
                        </td>
                        <td className='text-center  table-data'>
                            <input className='w-full p-2' type="text" placeholder='Search'
                                onChange={(e) => {
                                    changeSearchFilter("poDate", e.target.value, (item) => item)
                                }} />
                        </td>
                        <td className='text-center  table-data'>
                            <input className='w-full p-2' type="text" placeholder='Search'
                                onChange={(e) => {
                                    changeSearchFilter("dueDate", e.target.value, (item) => item)
                                }} />
                        </td>
                        <td className='text-center table-data'>
                            <input className='w-full p-2' type="text" placeholder='Search'
                                onChange={(e) => {
                                    changeSearchFilter("yarnId", e.target.value, (item) => findFromList(item, yarnList.data, "aliasName"))
                                }} />
                        </td>
                        <td className='text-center table-data'>
                            <input className='w-full p-2' type="text"
                                onChange={(e) => {
                                    changeSearchFilter("colorId", e.target.value, (item) => findFromList(item, colorList.data, "name"))
                                }}
                            />
                        </td>
                        <td className='text-center table-data'>
                            <input className='w-full p-2' type="text"
                                onChange={(e) => {
                                    changeSearchFilter("uomId", e.target.value, (item) => findFromList(item, uomList.data, "name"))
                                }}
                            />
                        </td>
                        <td className='text-center table-data'>
                        </td>
                        <td className='text-center table-data'>
                        </td>
                        <td className='text-center table-data'>
                        </td>
                        <td className='text-center table-data'>
                        </td>
                        <td className='text-center table-data'>
                        </td>
                        <td className='text-center table-data'>
                        </td>
                    </tr>
                    {localItems.map((item, index) =>
                        <tr key={index} className='table-row'>{console.log(localItems, "localitems")}
                            <td className='text-center p-1 table-data'>
                                <input type="checkbox" className='table-data-input' onChange={(e) =>
                                    handleCheckBoxChange(item.poNo, !isItemInPoAdded(item.poNo, item.poItemId), item.poItemId)}
                                    checked={isItemInPoAdded(item.poNo, item.poItemId)} />
                            </td>
                            <td className='text-left px-1 table-data'>
                                {count++}
                            </td>
                            <td className='text-left px-1 table-data'>
                                {item.poDocId}
                            </td>
                            <td className='text-left px-1 table-data'>
                                {getDateFromDateTime(item.poDate)}
                            </td>
                            <td className='text-left px-1  table-data'>
                                {getDateFromDateTime(item.dueDate)}
                            </td>
                            <td className='text-left px-1 table-data'>
                                {findFromList(item.yarnId, yarnList.data, "aliasName")}
                            </td>
                            <td className='text-left px-1 table-data'>
                                {findFromList(item.colorId, colorList.data, "name")}
                            </td>
                            <td className='text-left px-1 table-data'>
                                {findFromList(item.uomId, uomList.data, "name")}
                            </td>
                            <td className='text-right px-1 table-data'>
                                {substract(item.qty, item.alreadyCancelQty).toFixed(3)}
                            </td>
                            <td className='text-right px-1 table-data'>
                                {(item.alreadyInwardedQty + item.alreadyReturnedQty).toFixed(3)}
                            </td>
                            <td className='text-right px-1 table-data'>
                                {substract(substract(item.qty, item.alreadyCancelQty), (item.alreadyInwardedQty + item.alreadyReturnedQty)).toFixed(3)}
                            </td>
                            <td className='text-right px-1 table-data'>
                                {parseFloat(item.stockQty).toFixed(3)}
                            </td>
                            <td className='text-right px-1 table-data'>
                                {item.price}
                            </td>
                            <td className='text-right px-1 table-data'>
                                {(parseFloat(item.price) * parseFloat(item.qty)).toFixed(2)}
                            </td>
                        </tr>
                    )
                    }
                </tbody>
            </table>
        </div>

    )
}

export default YarnPoItemSelection